// The draft a submit-shaped payload stands for: what the library's Save hands to callbackMethod('submit') and a local
// panel's Save hands to onSubmit (templateSend/shared/submitData.js). Message saves it, and remembers the same mapping
// while a panel is open (its onValuesChange hands over the same payload, built without validation).
// Pure, so it is tested on its own. The three outer fields are the message's own and come from the host's state.
export function draftFromSubmitData(data, { destination, consentCategory, templateName } = {}) {
  return {
    channelId: data.channelId,
    templateId: String(data.templateId),
    messageType: data.messageType || 'text',
    params: data.params || [],
    headerParams: data.headerParams || [],
    mediaUrl: data.mediaUrl || null,
    fileName: data.fileName || null,
    location: data.location || null,
    buttonUrlParam: data.buttonUrlParam || null,
    ctaButtonUrl: data.ctaButtonUrl || null,
    waTemplateJson: (data.sub_type === 'COMPLEX' || data.sub_type === 'CAROUSEL' || data.sub_type === 'LTO') ? data.waTemplateJson : null,
    templateName,
    isTemplate: data.isTemplate === true,
    destination,
    consentCategory,
  };
}

// What a panel reports and a Save stores. Destination and consent are the message's own, and fileName is derived.
const VALUE_FIELDS = ['params', 'headerParams', 'mediaUrl', 'location', 'buttonUrlParam', 'ctaButtonUrl', 'waTemplateJson'];

// Whether two drafts hold the same typed values. The JSON text is the comparison, as it is for the panels' own report key;
// an unset field equals null. A false "same" would hide an unsaved edit, so equal means equal text. A false "different"
// only asks for a Save that was not needed. It compares what one panel wrote: a node the shared component saved holds its
// JSON in the library's format, so Message measures a panel's reports against the panel's own first one (savedReportRef).
export const sameValues = (a, b) => VALUE_FIELDS.every((field) => JSON.stringify(a[field] ?? null) === JSON.stringify(b[field] ?? null));
